import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getInformations } from '../../../../api/information/queries/getInformations';
import { IInformation } from '../../../../interfaces/Information.interfaces';

interface IUseGetInformationsQueryParams {
  searchParam: {
    type?: 'popular';
    category?: 'MAGAZINE' | 'NEWS';
    count?: number;
  };
}

export const useGetInformationsQuery = ({ searchParam }: IUseGetInformationsQueryParams) => {
  return useQuery<IInformation[], AxiosError>(
    ['informations', `type=${searchParam.type}`, `category=${searchParam.category}`, `count=${searchParam.count}`],
    () => getInformations({ searchParam }),
  );
};
